export const menuHeadingText = {
    breakfast: "Good Morning",
    brunch: "Good Afternoon!",
    lunch: "Good Afternoon!",
    dinner: "Good Evening",
    "happy hour": "Cheers!",
};
export const EVENTTYPELG = [
    {
        eventType: "live music",
        lg: "linear-gradient(180deg, #111111 0%, #D37547 100%)",
    },
    {
        eventType: "bollywood dj night",
        lg: "linear-gradient(180deg, #111111 0%, #FB7D00 178.72%)",
    },
    {
        eventType: "ladies dj night",
        lg: "linear-gradient(180deg, #111111 0%, #F35FDA 178.72%)",
    },
    {
        eventType: "techno dj night",
        lg: "linear-gradient(180deg, #111111 0%, #07786E 100%)",
    },
    {
        eventType: "hip hop dj night",
        lg: "linear-gradient(180deg, #111111 0%, #6B5547 100%)",
    },
    {
        eventType: "glow in the dark night",
        lg: "linear-gradient(180deg, #111111 0%, #000000 100%)",
    },
    {
        eventType: "comedy nights",
        lg: "linear-gradient(180deg, #111111 0%, #3B3422 100%)",
    },
    {
        eventType: "quiz night",
        lg: "linear-gradient(180deg, #111111 0%, #835D69 100%)",
    },
    {
        eventType: "brunch",
        lg: "linear-gradient(180deg, #111111 0%, #C0684C 100%)",
    },
    {
        eventType: "sports screening",
        lg: "linear-gradient(180deg, #111111 0%, #4B7001 100%)",
    },
    {
        eventType: "commercial night",
        lg: "linear-gradient(180deg, #111111 0%, #8B8080 100%)",
    },
    {
        eventType: "bolly techno",
        lg: "linear-gradient(180deg, #111111 0%, #4B7001 100%)",
    },
    {
        eventType: "garba night",
        lg: "linear-gradient(180deg, #111111 0%, #EB9969 100%)",
    },
    {
        eventType: "house party",
        lg: "linear-gradient(180deg, #111111 0%, #000000 100%)",
    },
];
export const getEventTypeLG = (eventType) => {
    const defaultBg = "linear-gradient(180deg, #111111 0%, #FB7D00 178.72%)";
    if (!eventType) {
        return defaultBg;
    }
    const event = EVENTTYPELG.find((item) => item.eventType === eventType.toLowerCase());
    return (event === null || event === void 0 ? void 0 : event.lg) || defaultBg;
};
export const EVENTTYPEBG = [
    { eventType: "bollywood", bg: "rgba(249, 150, 1, 1)" },
    { eventType: "diwali", bg: "rgba(249, 150, 1, 1)" },
    { eventType: "ladies", bg: "rgba(222, 131, 255, 1)" },
    { eventType: "techno", bg: "rgba(131, 241, 255, 1)" },
    { eventType: "sports", bg: "rgba(131, 255, 158, 1)" },
    { eventType: "garba", bg: "rgba(224, 49, 49, 1)" },
    { eventType: "halloween", bg: "rgba(224, 49, 49, 1)" },
    { eventType: "holi", bg: "rgba(224, 198, 49, 1)" },
    { eventType: "default", bg: "rgba(163, 131, 255, 1)" },
];
export const getEventTypeBg = (eventType) => {
    var _a;
    const defaultBg = "rgba(163, 131, 255, 1)";
    if (!eventType) {
        return defaultBg;
    }
    const event = EVENTTYPEBG.find((item) => eventType.toLowerCase().includes(item.eventType));
    return (_a = event === null || event === void 0 ? void 0 : event.bg) !== null && _a !== void 0 ? _a : defaultBg;
};
export const LINEBG = [
    {
        eventType: "bollywood",
        bg1: "rgba(249, 150, 1, 1)",
        bg2: "rgba(255, 210, 142, 1)",
    },
    {
        eventType: "diwali",
        bg1: "rgba(249, 150, 1, 1)",
        bg2: "rgba(255, 210, 142, 1)",
    },
    {
        eventType: "ladies",
        bg1: "rgba(222, 131, 255, 1)",
        bg2: "rgba(242, 206, 255, 1)",
    },
    {
        eventType: "techno",
        bg1: "rgba(131, 241, 255, 1)",
        bg2: "rgba(179, 246, 255, 1)",
    },
    {
        eventType: "sports",
        bg1: "rgba(131, 255, 158, 1)",
        bg2: "rgba(226, 255, 232, 1)",
    },
    {
        eventType: "garba",
        bg1: "rgba(224, 49, 49, 1)",
        bg2: "rgba(255, 151, 151, 1)",
    },
    {
        eventType: "halloween",
        bg1: "rgba(224, 49, 49, 1)",
        bg2: "rgba(255, 151, 151, 1)",
    },
    {
        eventType: "holi",
        bg1: "rgba(224, 198, 49, 1)",
        bg2: "rgba(255, 239, 149, 1)",
    },
    {
        eventType: "default",
        bg1: "rgba(127, 84, 251, 1)",
        bg2: "rgba(188, 165, 255, 1)",
    },
];
export const getLineBg = (eventType) => {
    const defaultBg = {
        bg1: "rgba(127, 84, 251, 1)",
        bg2: "rgba(188, 165, 255, 1)",
    };
    if (!eventType) {
        return defaultBg;
    }
    const event = LINEBG.find((item) => eventType.toLowerCase().includes(item.eventType));
    return (event === null || event === void 0 ? void 0 : event.eventType) ? event : defaultBg;
};
export const defaultColors = {
    primaryVariant1: "#1e1e1e",
    primaryVariant2: "#111111",
    onPrimary: "#ffffff",
    primaryContainer: "#1e1e1e",
    onPrimaryContainer: "#ffffff",
    secondaryContainer: "#a383ff",
    onSecondaryContainer: "#ffffff",
};
export const IMG_URL = process.env.REACT_APP_ASSETS_PREFIX_URL
    ? process.env.REACT_APP_ASSETS_PREFIX_URL + "/web-assets/customer"
    : "";
